var modules_ef1f9f15 = {"tabs":"_3heknq","wrap":"_2rq8di","panes":"_k7mdpr","tab":"_1ausror","view-text":"_181krkc","color-gray":"_1gp6g87","color-light":"_volupm","active":"_1mrgcie","color-dark":"_1r4t80k","pane":"_g4umjj"};
import "../../../assets/Dki8fBn-.css";

export { modules_ef1f9f15 as default };
//# sourceMappingURL=Tabs.module.less.js.map
